(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("wavesurfer.js"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "wavesurfer"], factory);
	else if(typeof exports === 'object')
		exports["plugins/timeline"] = factory(require("react"), require("prop-types"), require("wavesurfer.js"));
	else
		root["Wavesurfer"] = root["Wavesurfer"] || {}, root["Wavesurfer"]["plugins/timeline"] = factory(root["React"], root["prop-types"], root["WaveSurfer"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition